import { useEffect } from "react";

import PC from "./pc";
import Mobile from "./mobile";

import Constant from "utils/headFootConstants";
import { isLocalDevelop } from "utils/debug";

import { CommonRuntime, Platform, setRuntime } from "utils/runtime";
import { ParseProductTagFromUrlResp } from "utils/playground/url";
import { TPlayground, TModule } from "services/page/admin";
import { TFrontModule } from "services/page/app";

export interface MainProps {
	page: TPlayground;
	modules: TFrontModule[];
	frontModules: TModule[];
	tagQuery: ParseProductTagFromUrlResp;
	runtime: CommonRuntime;
	canScrollFixed?: boolean;
}

export default function Main(props: MainProps) {
	const { runtime } = props;
	const { platform } = runtime;
	const isPC = platform === Platform.WEB;

	Constant.isDev = runtime ? isLocalDevelop(runtime?.hostname) : true;
	Constant.isUat = runtime ? runtime?.isUat : true;
	Constant.sessionKey = runtime?.cookies?.["sessionKey"] || "";
	Constant.isLogin = !!runtime?.cookies?.["sessionKey"];

	Constant.sid = runtime?.sid || "0";
	Constant.country = runtime?.countryCode3 || "USA";
	Constant.countryCode2 = runtime?.countryCode2 || "US";
	Constant.language = runtime?.languageCode || "en";
	Constant.currency = runtime?.currency || "USD";
	Constant.platform = runtime?.platform;
	Constant.countryId = runtime?.countryId || "223";

	useEffect(() => {
		setRuntime(runtime);
	});
	return isPC ? <PC {...props} /> : <Mobile {...props} />;
}
